/**
 * Named container query for toolbars that collapse button labels when the
 * toolbar itself (not the viewport) runs out of room — e.g. sidebar + side
 * panel on a small screen.
 *
 * Put `toolbarContainerClass` on the toolbar row. Labels using the hide
 * classes stay visible when there is no named container ancestor.
 *
 * The container element must get its width from its parent (e.g. a block or
 * `w-full` element). `container-type: inline-size` stops an element being sized
 * by its contents, so a content-sized element (`inline-flex`, `ml-auto` in a
 * wrap row) would collapse and report a misleadingly narrow width.
 */
export const toolbarContainerClass = '@container/toolbar';

/** Sync / Upload / Create folder labels. */
export const toolbarActionLabelClass = '@max-[1100px]/toolbar:hidden';

/** Compact-only content (single Sync glyph). Inverse of the 1100px action threshold. */
export const toolbarCompactOnlyClass = '@min-[1100px]/toolbar:hidden';

/** Expanded-only flex row (full Sync icons). */
export const toolbarExpandedFlexClass = 'hidden @min-[1100px]/toolbar:flex';

/** Filters label — hide only when space is really tight. */
export const toolbarFilterLabelClass = '@max-[950px]/toolbar:hidden';

/**
 * Toolbar container width (px) at or below which {@link toolbarFilterLabelClass}
 * collapses the Filters / Source Folders labels to icon-only. Kept in sync with
 * the 950px threshold in that class so JS (e.g. compact-only tooltips) can tell
 * when a button has become icon-only. Must match the value above.
 */
export const TOOLBAR_FILTER_LABEL_HIDE_MAX_WIDTH = 950;
